/* eslint-disable no-unused-vars */
import React from 'react'
import { BsFileEarmarkPdfFill } from 'react-icons/bs'
import { TbCloudUpload } from 'react-icons/tb'
import { Avatar, Box, Button, Col, Dialog, Flex, Gap, Row, Typography } from '../../../ppui'
import { logger } from '../../../utils/logger'
import { ImportAttendance } from '../../style'
import useEmployeeImportSevice from './use-employee-import-sevice'

const EmployeeImport = ({ openImportModal, handleOpenImportModal, handleCloseImportModal,getEmployeeListFn }) => {
    const {
        handleFileChange,
        errorLogs,
        importSuccessMsg,
        handleDrop,
        handleDragOver,
        handleDragLeave,
        isDragging,
        fileName,
        ValidateUploadEmployeeCSV,
        file,
        isLoadingBtn,
        handleSampleCSVdownload,
        isImportBtnDisable,
        showTryAgainBtn,
        isValidateBtnDisable,
        finalUploadEmployeeCSV,
        handleTryAgainBtn,
        readyToUploadData
    } = useEmployeeImportSevice({handleCloseImportModal,getEmployeeListFn,openImportModal});
    logger.log(showTryAgainBtn, "showTryAgainBtn")
    return (
        <>
            {/* ImportModal */}
            <Dialog
                title="Import Employee"
                closeButton={true}
                fullWidth
                maxWidth="sm"
                buttonName={"Update"}
                open={openImportModal}
                onClose={handleCloseImportModal}
                onSubmit={() => alert("Submitted")}
                action={false}
                bodyScroll={true}
                separator
            >
                <ImportAttendance
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    align="center"
                    p={4}
                    border="1px dashed #ccc"
                    borderRadius="8px"
                    bgcolor={isDragging ? "#f0f0f0" : "transparent"}
                    width="100%"
                    style={{ cursor: "pointer" }}
                >
                    <Flex direction={"column"}>
                        <Box align="center" mb={10}>
                            <Avatar icon={<TbCloudUpload />} size="lg" variant="outlined" />
                        </Box>
                        <Box>
                            <Typography color="primary" variant="h5" mb="15" align="center">
                                Choose a file or drag & drop it here
                            </Typography>
                            <Typography variant="h6" mb="0" align="center">
                                CSV formats, up to 50MB
                            </Typography>
                            <input
                                type="file"
                                id="fileInput"
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                            />
                            <Box mt="20" align="center">
                                <Button
                                    color="primary"
                                    variant="outlined"
                                    onClick={() => document.getElementById("fileInput").click()}
                                >
                                    Browse File
                                </Button>
                            </Box>
                        </Box>
                        {fileName && (
                            <Box mt="20" align="center">
                                <Typography variant="body2" color="secondary" align="center">
                                    {fileName}
                                </Typography>
                            </Box>
                        )}
                    </Flex>
                </ImportAttendance>
                <Gap height={40} />
                {
                    // selectedMonth && selectedYear && <>
                    <Row rowGap alignItem={"center"}>
                        <Col sm={12} md={4} lg={8}>
                            <Flex gap={20} alignItem={"center"}>
                                <Box>
                                    <Avatar shape="square" icon={<BsFileEarmarkPdfFill />} />
                                </Box>
                                <Box>
                                    <Typography variant="body2" mb={"0"} color={"dark"}>
                                        {`Sample copy of exports Employee`}
                                    </Typography>
                                </Box>
                            </Flex>
                        </Col>

                        <Col xs={"auto"} ml={"auto"}>
                            <Flex gap={10}>
                                <Button
                                    onClick={() => handleSampleCSVdownload()}
                                    variant="filled"
                                    size="sm"
                                    color="danger"
                                >
                                    Download
                                </Button>
                            </Flex>
                        </Col>
                    </Row>
                    // </>
                }
                {/* {
                    errorLogs && errorLogs.map((item, index) => (
                        <Box key={index}>
                            <Typography variant="body2" color="danger">{item?.errors?.map(item,index)=>(
                                
                            )}</Typography>
                        </Box>
                    ))
                } */}
                {importSuccessMsg && <Typography variant="body2" color="success">{importSuccessMsg}</Typography>}
                {
                    errorLogs && errorLogs.map((log, index) => (
                        <Box key={index}>
                            <Typography variant="body2" color="danger">
                                {`Row ${log.rowNumber}:`}
                                {log.errors.map((error, errorIndex) => (
                                    <div key={errorIndex}>{error}</div>
                                ))}
                            </Typography>
                        </Box>
                    ))
                }

                <Gap height={40} />
                <Row specing={"80"}>
                    <Col xs="12" sm="6">
                        <Button
                            color="primary"
                            fullWidth
                            variant="contained"
                            disabled={isImportBtnDisable}
                            onClick={()=>finalUploadEmployeeCSV(readyToUploadData)}
                        >
                            Import Employee
                        </Button>
                    </Col>
                    <Col xs="12" sm="6">
                        {!showTryAgainBtn &&
                            <Button
                                color="primary"
                                fullWidth
                                onClick={() => ValidateUploadEmployeeCSV(file)}
                                variant="contained"
                                loading={isLoadingBtn}
                                disabled={isValidateBtnDisable}
                            >
                                Validate Employee
                            </Button>}
                        {showTryAgainBtn &&
                            <Button
                                color="primary"
                                fullWidth
                                variant="contained"
                                loading={isLoadingBtn}
                                onClick={()=>handleTryAgainBtn()}
                            >
                                Try Again
                            </Button>}

                    </Col>
                </Row>
            </Dialog>
            {/* ImportModal */}
        </>
    )
}

export default EmployeeImport